module.exports = __webpack_public_path__ + "53dab8db90a4dda72c693b4dc32bcbb6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-zig-mint-s.png
// module id = 1999
// module chunks = 0